import { defineComponent as n, openBlock as r, createBlock as t, unref as l, mergeProps as p, withCtx as d, createElementVNode as e } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const M = /* @__PURE__ */ n({
  name: "IconTouchbar",
  __name: "IconTouchbar",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(h) {
    const o = h;
    return (v, a) => (r(), t(l(u), p(o, { "view-box": "0 0 24 24" }), {
      default: d(() => [...a[0] || (a[0] = [
        e("path", {
          "fill-rule": "evenodd",
          d: "M5.5 7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-8M6 8.5v1h7v-1H6M16.5 7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-2M17 8.5v1h1v-1h-1",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", { d: "M4.5 12.75A.75.75 0 0 1 5.25 12h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75m4.167 0A.75.75 0 0 1 9.417 12h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75M13.583 12a.75.75 0 0 0 0 1.5h1a.75.75 0 1 0 0-1.5h-1M17 12.75A.75.75 0 0 1 17.75 12h1a.75.75 0 0 1 0 1.5h-1A.75.75 0 0 1 17 12.75M5.25 15a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1M9 15.75A.75.75 0 0 1 9.75 15h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 9 15.75M17.75 15a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M2.25 8A3.25 3.25 0 0 1 5.5 4.75h13A3.25 3.25 0 0 1 21.75 8v8a3.25 3.25 0 0 1-3.25 3.25h-13A3.25 3.25 0 0 1 2.25 16V8M5.5 6.25A1.75 1.75 0 0 0 3.75 8v8a1.75 1.75 0 0 0 1.75 1.75h13A1.75 1.75 0 0 0 20.25 16V8a1.75 1.75 0 0 0-1.75-1.75h-13",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  M as default
};
